export default __webpack_public_path__ + "static/media/slide20.3acc217b.jpg";